export default "__VITE_ASSET__BSQvbdhW__"